import CustomData from "pages/_components/CustomData/CustomData";
import CustomText from "pages/_components/CustomText/CustomText";
import { bool, instanceOf, string } from "prop-types";
import React from "react";

export const SingleBill = ({ bill, paymentType, isRow }) => {
    const isSFM = paymentType === "SFM";
    const isCSF = paymentType === "CSF";
    const isUniqueBill = (isSFM || isCSF) && !isRow;

    if (bill.expired) {
        return null;
    }

    if (isUniqueBill) {
        return (
            <div className="d-flex justify-content-between my-6 flex-auto">
                {bill.details.map((detail) => (
                    <div key={`bill-${detail.label}`}>
                        <CustomData titleText={detail.label} valueText={detail.value} />
                    </div>
                ))}
            </div>
        );
    }

    if (isRow) {
        return (
            <>
                {bill.details.map((detail) => (
                    <div key={`bill-${detail.label}`}>
                        <CustomText text={detail.value} className="custom-data-value" />
                    </div>
                ))}
            </>
        );
    }

    return null;
};

SingleBill.propTypes = {
    bill: instanceOf(Object).isRequired,
    paymentType: string.isRequired,
    isRow: bool,
};

SingleBill.defaultProps = {
    isRow: false,
};

export default SingleBill;
